import React, {useState, useEffect} from 'react';
import styled from 'styled-components';
import ReactNewWindow from 'react-new-window'
import Portal from '../../stacks/portal/PortalAWS'
import {useErrorToast} from '../../hooks/useErrorToast';
import 'react-quill/dist/quill.snow.css'

const DisplaySampleScreen = props => {
  const {setErrorMsg, errorToast} = useErrorToast('');

  const [, setLoading] = useState(false)
  const [, setLoadingMsg] = useState('Loading ...')
  const [value, setValue] = useState('')

  useEffect(() => {
    async function get() {
      try {
        const portal = Portal.getInstance()
        setErrorMsg('')
        setLoading(true)
        setLoadingMsg(`Loading ...`)
        const content = await portal.retrieveContentSample()
        setValue(content)
        setLoading(false)
      }
      catch (err) {
        console.log(`INFO Portal retrieveContentSample ${err.message}`)
        setLoading(false)
        setErrorMsg(err.message)
        setValue("<p>Sample Not Found</p>")
      }
    }
    get()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  function createMarkup() {
    if (value === '') {
      return {__html: '<p/>'}
    }
    return {__html: value};
  }

  function unload() {
    console.log(`unload Sample`)
  }

  return (
    <ReactNewWindow title='DreamEx Sample' features={{
      // noopener: '_blank',
      location: 'no',
      status: 'no',
      menubar: 'no',
      width: '800px',
      height: '600px'

      }}
      onunload={unload}>
      <div className='ql-container' >
        <div className='ql-snow'>
          <div className='ql-editor'  dangerouslySetInnerHTML={createMarkup()}/>
        </div>
        <Copyright>&copy; 2020 Dream Exchange LLC</Copyright>
      </div>
      {errorToast}
    </ReactNewWindow>
  )
};

const Copyright = styled.div`
font-size: x-small;
margin-left: 2em;
`

export default DisplaySampleScreen
